// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AdminCreateUser_wrapper","wrapperCreated":"AdminCreateUser_wrapperCreated"};